module.exports = "/assets/data/06ea2246de3cf891fce090528c53ca3f-SA5.data.json";